export default __webpack_public_path__ + "6851cf6a577eb290701e61ee05c1aa4a.png";